import FilterView from 'view/activity/filterView';
import PartialOverpanelView from 'widgets/partialOverpanel';
import { extend } from 'underscore';
import Backbone from 'backbone';
import moment from 'moment';
import * as presets from 'widgets/datepickerPresets';
import { getActiveShortcut } from 'view/activity/dateRangePicker/stores/shortcutHandling';
const $ = Backbone.$;

const FilterNativeMobileView = FilterView.extend({
	// template: 'activity/inc/filtersOverpanel', // template renders into overpanel

	events: function() {
		return extend(FilterNativeMobileView.__super__.events, {
			'click .js_customDates-shortcut': 'onClickShortcut',
			'click .js_filters-dateButton': 'onClickDateButton'
		});
	},

	initialize () {
		// sets the model and validateForm instance
		FilterNativeMobileView.__super__.initialize.apply(this, arguments);

		// Set isDesktopView to false
		this.model.set('isDesktopView', false);
	},

	onClickShortcut (event) {
		let $button = $(event.target),
			presetName = $button.data('preset'),
			[startDate, endDate] = presets[presetName]();
		this.model.setDateFromObject('startDate', startDate);
		this.model.setDateFromObject('endDate', endDate);
		Backbone.trigger(
			'trackLink',
			null,
			presetName,
			`main:walletweb:activity:opencalendar:${presetName}`,
			null,
			'link'
		);
		this.onFilterView(event);
	},

	openOverlay ({ contentsSelector, onShow, onHide }) {
		if (this._showingOverlay === contentsSelector) {
			return;
		}
		this._showingOverlay = contentsSelector;
		if (this._currentOverlay) {
			this._currentOverlay.destroy().done(() => {
				this.openOverlay({ contentsSelector, onShow });
			});
		} else {
			this._currentOverlay = new PartialOverpanelView({
				el: this.$(contentsSelector)[0],
				container: $('#js_foreground'),
				offsetTop: $('.globalNav_mobile').outerHeight()
			});

			let $originalEl = this.$el;
			// do not use this.setElement as it will undelegate existing events--we want to duplicate listeners, not swap them
			this.$el = this._currentOverlay.$el;
			if (this.$el !== $originalEl) {
				this.delegateEvents();
			}

			if (onShow) {
				this._currentOverlay.on('show', onShow);
			}

			this._currentOverlay.on('destroy', () => {
				this._showingOverlay = false;
				this._currentOverlay = null;
				if (this.$el !== $originalEl) {
					this.undelegateEvents();
					// do not use this.setElement because the original events are still delegated
					this.$el = $originalEl;
				}
				if (onHide) {
					onHide.call(this._currentOverlay);
				}
			});
		}
	},

	getDatePickerElement() {
		return $('.js_customDates-mobileDatePicker')
			.css('display', 'none')
			.removeClass('visible-phone');
	},

	onClickDateButton (event) {
		event.preventDefault();
		if (this.datePicker) {
			this.delegateEvents();
		}
		this.openOverlay({
			contentsSelector: '#js_datePicker',
			onShow: () => {

				// load preset by default if nothing set in the model
				let startDate,
					endDate;
				if (this.model.hasStartDate() && this.model.hasStartDate()) {
					startDate = this.model.get('startDate');
					endDate = this.model.get('endDate');
				} else {
					[startDate, endDate] = presets.last90();
				}

				// this it the standard date format for HTML5 date inputs
				let inputDateFormatString = 'YYYY-MM-DD';

				/* The mobile date fields are date inputs that are hidden but sit right on top of the normal text inputs
				 * normal date inputs can't have custom date formats so clicking on the hidden date input will trigger
				 * the native datepicker component and selecting a date with the native datepicker will trigger
				 * a search and update the text field to show the date with our custom date format */
				let mobileStartDateField = this.$('.js_filters-startDate-mobile');
				let mobileEndDateField = this.$('.js_filters-endDate-mobile');
				let startDateField = this.$('.js_filters-startDate');
				let endDateField = this.$('.js_filters-endDate');

				// actions for the start date field
				mobileStartDateField
					.val(formatDate(inputDateFormatString, startDate))
					.on('input', () => {
						// if valid value, for iOS we change the value of the text field, for others we trigger selection
						if (mobileStartDateField.val()) {
							startDateField.val(formatDate(this.dateFormatString, mobileStartDateField.val()));
							if (!['iPad', 'iPhone', 'iPod'].includes(navigator.platform)) {
								this.onDatePickerSelect(startDate, startDateField.val(), event);
							}
						} else {
							// if no valid value or "clear" we reset the field to the initial date
							startDateField.val(formatDate(this.dateFormatString, startDate));
							mobileStartDateField.val(formatDate(inputDateFormatString, startDateField.val()));
						}
					})
					.on('blur', () => {
						// only trigger selection if focus is on same field, "done" event
						setTimeout(() => {
							 if (this.$('.filters-startDate').hasClass('active')) {
								this.onDatePickerSelect(formatDate(this.dateFormatString, startDate), startDateField.val(), event);
							}
						}, 500);
					})
					.on('focus', () => {
						// add focus to the fields and add mobileborder to overrride blue border from touch event
						this.$('.filters-startDate').addClass('active');
						this.$('.filters-endDate').removeClass('active').addClass('mobileBorder');
					});

				// actions for the end date fieldsd
				mobileEndDateField
					.val(formatDate(inputDateFormatString, endDate))
					.on('input', () => {
						// for iOS we change the value of the text field, for others we trigger selection
						if (mobileEndDateField.val()) {
							endDateField.val(formatDate(this.dateFormatString, mobileEndDateField.val()));
							if (!['iPad', 'iPhone', 'iPod'].includes(navigator.platform)) {
								this.onDatePickerSelect(endDate, endDateField.val(), event);
							}
						} else {
							// if no valid value or "clear" we reset the field to the initial date
							endDateField.val(formatDate(this.dateFormatString, endDate));
							mobileEndDateField.val(formatDate(inputDateFormatString, endDate));
						}
					})
					.on('blur', () => {
						// only trigger selection if focus is on same field, "done" event
						setTimeout(() => {
							 if (this.$('.filters-endDate').hasClass('active')) {
								this.onDatePickerSelect(formatDate(this.dateFormatString, endDate), endDateField.val(), event);
							 }
						}, 500);
					})
					.on('focus', () => {
						// add focus to the fields and add mobileborder to overrride blue border from touch event
						this.$('.filters-endDate').addClass('active');
						this.$('.filters-startDate').removeClass('active').addClass('mobileBorder');
					});

				// set values for start date text field, don't allow manually entering dates into fields, remove placeholder and remove from tab order
				startDateField
					.val(formatDate(this.dateFormatString, startDate))
					.attr('tabIndex', '-1')
					.attr('readOnly', true)
					.attr('placeholder', '');

				// set values for end date text field, don't allow manually entering dates into fields, remove placeholder and remove from tab order
				endDateField
					.val(formatDate(this.dateFormatString, endDate))
					.attr('tabIndex', '-1')
					.attr('readOnly', true)
					.attr('placeholder', '');

				// highlight the active shortbut
				let activeShortcut = getActiveShortcut(startDate, endDate);
				this.$('.js_customDates-shortcut')
					.removeClass('active')
					.filter(`[data-preset="${activeShortcut}"]`)
					.addClass('active');

			},
			onHide: () => {
				// hide the month view when the overlay hides, to restore
				// the initial state of the date picker UI
				this.getDatePickerElement().css('display', 'none');
			}
		});
	},

	onDatePickerSelect (lastDate, selectedDate, event) {
		let selectedStartDate = this.$('.js_filters-startDate-mobile').val();
		let selectedEndDate = this.$('.js_filters-endDate-mobile').val();
		if (selectedDate !== lastDate) {
			this.model.setDateFromObject('startDate', selectedStartDate);
			this.model.setDateFromObject('endDate', selectedEndDate);
			this.onFilterView(event);
		}
	},

	/* Click handler for "View"
	 * Hide the overpanel */
	onFilterView (event) {
		let isFreeTextSearch = $(event.delegateTarget).hasClass('js_freeTextSearch');
		if (!isFreeTextSearch) {
			this.freeTextSearchView.clearFreeTextSearch(event);
			this.setupDataForDateSearch();
		}
		// call super class method for inherited behavior
		FilterNativeMobileView.__super__.onFilterView.apply(this, arguments);
		// close the overpanel, don't trigger auto-navigation to /myaccount/activity
		if (this._currentOverlay) {
			this._currentOverlay.destroy();
		}
	},

});

export const formatDate = (format, date) => moment(date).format(format);
export default FilterNativeMobileView;



// WEBPACK FOOTER //
// ./view/activity/filterNativeMobileView.es6